{
  "caption": "Ten phases by ten phases. Rows are the question's phase, columns the chosen option's phase.",
  "rows": {
    "pluto": "Spirit",
    "neptune": "Management",
    "uranus": "Leadership",
    "saturn": "Requirements",
    "sun": "Conceptualisation",
    "moon": "Assessment",
    "mars": "Development",
    "mercury": "Image",
    "jupiter": "Organisation",
    "venus": "Closure"
  },
  "cols": {
    "pluto": "Culture",
    "neptune": "Management",
    "uranus": "Leadership",
    "saturn": "Cycle",
    "sun": "Projection",
    "moon": "Reflection",
    "mars": "Development",
    "mercury": "Design",
    "jupiter": "Operations",
    "venus": "Results"
  },
  "stats": {
    "total": "Σ",
    "totalLabel": "Total",
    "sd": "SD",
    "sdLabel": "Standard deviation",
    "kurtosis": "K",
    "kurtosisLabel": "Excess kurtosis",
    "undefined": "—",
    "grid": "Whole grid",
    "gridSummary": "n {{n}} · Σ {{total}} · SD {{sd}} · K {{kurtosis}}"
  }
}
